<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.timeout = null;
    this.searchSeq = 0;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.stopSearch();
    this.searchSeq++;
  },

  watch: {
    search(val) {
      if (!val) {
        this.stopSearch();
        this.items = [];
        return;
      }

      if (this.select && val === this.select.text) {
        this.stopSearch();
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    stopSearch() {
      this.searchSeq++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopSearch();

      const seq = this.searchSeq;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoderReady.then(geocoder => {
          if (seq !== this.searchSeq) {
            return;
          }

          return geocoder.autocomplete(value).then(items => {
            if (seq === this.searchSeq) {
              this.items = items.slice();
            }
          });
        }).catch(err => {
          if (!(err && err.cancelled) && seq === this.searchSeq) {
            this.items = [];
          }
        }).finally(() => {
          if (seq === this.searchSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopSearch();
      this.$emit("change", o);
    }
  }
};
</script>
